// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2KGYY","addWidgetButton":"Header_addWidgetButton__jcjXr","dashboardTabs":"Header_dashboardTabs__1JtvI","active":"Header_active__3tifT"};